import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13 3a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0zM9 6.5c0-.289-.036-.795-.385-1.174a1.18 1.18 0 0 0-.862-.384 1.3 1.3 0 0 0-.714.212 9.32 9.32 0 0 0-4.36 7.893c0 4.191 2.764 7.734 6.567 8.908l.036.012.038.008c1.034.235 1.887.367 2.742.368.86.001 1.677-.13 2.642-.373l.025-.007.025-.008c3.803-1.174 6.568-4.717 6.568-8.908a9.32 9.32 0 0 0-4.28-7.842c-.318-.204-.936-.405-1.497.026-.47.362-.545.923-.545 1.27v2.632c0 .46-.174 1.05-.607 1.514-.41.442-1.132.853-2.393.853s-1.982-.411-2.393-.853A2.28 2.28 0 0 1 9 9.133z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_power_filled-DlsvB-bJ.js.map
